export default __webpack_public_path__ + "static/media/start-your-own-room.c6a29568.svg";